import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["drawer", "drawerNav"]

  connect() {
    // Frame navigation history so the drawer can go back to previous frame content
    this.navigationHistory = []
    this.currentPath = null
    // Set up a mutation observer to track content changes in the active-drawer-content frame
    this.frameObserver = new MutationObserver(this.frameContentChanged.bind(this))
    this.observeActiveFrame()

    document.addEventListener("drawer:open", this.openDrawer.bind(this))
    document.addEventListener("drawer:close", this.closeDrawer.bind(this))
  }

  disconnect() {
    if (this.frameObserver) this.frameObserver.disconnect()
    document.removeEventListener("drawer:open", this.openDrawer.bind(this))
    document.removeEventListener("drawer:close", this.closeDrawer.bind(this))
  }

  openDrawer() {
    this.drawerTarget.classList.add("open")
    this.drawerNavTarget.classList.add("open")
  }
  closeDrawer() {
    this.drawerTarget.classList.remove("open")
    this.drawerNavTarget.classList.remove("open")
  }

  back() {
    const previousPath = this.navigationHistory.pop()
    console.log('previousPath: ', previousPath)

    if (previousPath) {
      // Temporarily disable the observer to prevent duplicate history entries
      this.frameObserver.disconnect()
      const frame = document.getElementById("active-drawer-content")
      if (frame) {
        // Go to the previous turbo frame in the drawer
        Turbo.visit(previousPath, { frame: "active-drawer-content" })
      }
      this.currentPath = previousPath

      // Re-enable observer after navigation
      setTimeout(() => this.observeActiveFrame(), 100)

      this.updateBackButtonVisibility()
    }
  }

  updateBackButtonVisibility() {
    const backButton = this.element.querySelector(".back")
    if (backButton) {
      backButton.style.visibility = this.navigationHistory.length ? "visible" : "hidden"
    }
  }

  observeActiveFrame() {
    const activeFrame = document.getElementById("active-drawer-content")
    if (activeFrame) {
      this.frameObserver.observe(activeFrame, {
        childList: true,
        subtree: false
      })
    }
  }

  frameContentChanged(mutations) {
    // When frame content changes, store the previous path
    if (this.currentPath) {
      this.navigationHistory.push(this.currentPath)
    }

    // Get current URL from the Turbo visit
    const frame = document.getElementById("active-drawer-content")
    if (frame && frame.src) {
      this.currentPath = frame.src
    }
    this.updateBackButtonVisibility()
  }

  showMixtapes() {
    this.openDrawer()
    Turbo.visit("/my_mixtapes", { frame: "active-drawer-content" })
  }

  showCustomizeForm() {
    this.openDrawer()
    Turbo.visit("/customize_form", { frame: "active-drawer-content" })
  }
}
